import type { Abfrageergebnis, Berichtsbeschreibung, Darstellung } from '@crm/kontrakte';
import { fehlendeOptionen } from '@crm/kontrakte/src/diagrammarten';

/*
 * DIE WAHL EINER DIAGRAMMART IM BAUKASTEN (Auftrag CRM-89, ÄA-54) — ohne
 * React, damit die Regeln fuer sich pruefbar sind.
 */

/**
 * AUS-41: Wer eine Darstellung waehlt, bekommt die Optionen der ersten
 * Kennzahl dazu, die sie zeichnet — der Boxplot Min/Max, Median und
 * Quartile, 100 % den Anteil an der Zeile, die kumulierte Linie die laufende
 * Summe. Abwaehlen laesst sich jede danach wie sonst auch; dann zeigt der
 * Bericht Balken und sagt, was fehlt.
 */
export function mitOptionen(b: Berichtsbeschreibung, d: Darstellung, e: Abfrageergebnis | undefined): Partial<Berichtsbeschreibung> {
  const k = e?.kennzahlen[0]?.kennung;
  const fehlt = e === undefined ? [] : fehlendeOptionen(d, e);
  if (k === undefined || fehlt.length === 0) return { darstellung: d };
  const dazu = (liste: readonly string[] | undefined): string[] => [...new Set([...(liste ?? []), k])];
  return {
    darstellung: d,
    ...(fehlt.includes('minMax') ? { minMax: dazu(b.minMax) } : {}),
    /* Quartile gibt es nur mit dem Median (AUS-31). */
    ...(fehlt.includes('median') || fehlt.includes('quartile') ? { median: dazu(b.median) } : {}),
    ...(fehlt.includes('quartile') ? { quartile: dazu(b.quartile) } : {}),
    ...(fehlt.includes('anteil') ? { anteil: dazu(b.anteil), anteilAn: 'zeile' as const } : {}),
    ...(fehlt.includes('kumuliert') ? { kumuliert: dazu(b.kumuliert) } : {}),
  };
}

/**
 * AUS-36: eigene Grenzen als Text — „250; 500; 1000" oder „250 500 1000",
 * Komma oder Punkt als Dezimalzeichen.
 */
export function grenzenAusText(t: string): readonly string[] {
  return t
    .split(/[;\s]+/)
    .map((g) => g.trim().replace(',', '.'))
    .filter((g) => g !== '');
}

/**
 * AUS-36: warum Grenzen nicht taugen, oder null. Dieselben Regeln wie der
 * Kontrakt (eine bis zwoelf, streng steigend, hoechstens zwei
 * Nachkommastellen) — hier, damit die Maske den Grund nennt, bevor der
 * Server die Beschreibung abweist.
 */
export function grenzenGrund(grenzen: readonly string[]): string | null {
  if (grenzen.length > 12) return 'Höchstens zwölf Grenzen.';
  if (grenzen.some((g) => !/^-?\d{1,12}(\.\d{1,2})?$/.test(g))) return 'Grenzen sind Zahlen mit höchstens zwei Nachkommastellen.';
  const zahlen = grenzen.map(Number);
  if (zahlen.some((z, i) => i > 0 && z <= (zahlen[i - 1] ?? z))) return 'Die Grenzen steigen von links nach rechts.';
  return null;
}
